// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StripeElement,.StripeElementIdeal{display:block;margin:10px 0 20px 0;max-width:500px;padding:10px 14px;box-shadow:rgba(50,50,93,.14902) 0px 1px 3px,rgba(0,0,0,.0196078) 0px 1px 0px;border-radius:4px;background:#fff}.StripeElement--focus,.StripeElementIdeal--focus{box-shadow:rgba(50,50,93,.109804) 0px 4px 6px,rgba(0,0,0,.0784314) 0px 1px 3px;-webkit-transition:all 150ms ease;transition:all 150ms ease}.StripeElement.loading{height:41.6px;opacity:.6}.StripeElementIdeal{padding:0}", ""]);
// Exports
module.exports = exports;
